const API_BASE_URL = "https://shopify-tryon-backend-332763268957.us-central1.run.app";

document.addEventListener('DOMContentLoaded', function () {


    const openBtn = document.getElementById('ViewOnMeButton');
    const drawer = document.getElementById('viewOnMeDrawer');
    const closeBtn = document.querySelector('.view-on-me-close');
    const backBtn = document.querySelector('.view-on-me-back');
    const productInfo = document.querySelector('.product__info-container');
    const productInfoWrapper = document.querySelector('.product__info-wrapper');
    const productInfoMain = productInfo ? productInfo.querySelector('.product-info-main') : null;

    function openDrawer(){
        if(!drawer || !productInfo) return;
        drawer.setAttribute('aria-hidden','false');
        drawer.classList.add('is-open');
        productInfo.classList.add('is-drawer-open');
        if(productInfoWrapper) productInfoWrapper.classList.add('drawer-open');
        const focusable = drawer.querySelector('button, a, input, [tabindex]');
        if(focusable) focusable.focus();
    }

    function closeDrawer(){
        if(!drawer || !productInfo) return;
        drawer.setAttribute('aria-hidden','true');
        drawer.classList.remove('is-open');
        productInfo.classList.remove('is-drawer-open');
        if(productInfoWrapper) productInfoWrapper.classList.remove('drawer-open');
        if(openBtn) openBtn.focus();

        // Reset drawer state to upload container on close
        setTimeout(function(){
            resetDrawerState();
        }, 350);
    }

    const fileInput = document.getElementById('userPhoto');
    const previewWrapper = document.querySelector('.view-on-me-preview');
    const previewPlaceholder = previewWrapper ? previewWrapper.querySelector('.view-on-me-preview-placeholder') : null;
    const previewImageWrapper = previewWrapper ? previewWrapper.querySelector('.view-on-me-preview-image-wrapper') : null;
    const previewImage = document.getElementById('viewOnMePreviewImage');

    const uploadContainer = document.querySelector('.view-on-me-upload-container');
    const loadingContainer = document.querySelector('.view-on-me-loading-container');
    const resultContainer = document.querySelector('.view-on-me-result-container');
    
    const generateBtn = document.querySelector('.view-on-me-generate');
    const resetBtn = document.querySelector('.view-on-me-reset');
    const likeBtn = document.querySelector('.view-on-me-like-btn');
    const cartBtn = document.querySelector('.view-on-me-cart-btn');
    const downloadBtn = document.getElementById('viewOnMeDownloadBtn');
    
    const resultUserPhoto = document.getElementById('viewOnMeResultUserPhoto');
    const resultProductPhoto = document.getElementById('viewOnMeResultProductPhoto');

    function updatePreview(file){
        if(!previewWrapper || !previewPlaceholder || !previewImageWrapper || !previewImage) return;
        if(file && file.type.startsWith('image/')){
            const reader = new FileReader();
            reader.onload = function(event){
                previewImage.src = event.target.result;
                previewImageWrapper.classList.add('is-visible');
                previewImageWrapper.setAttribute('aria-hidden','false');
                previewPlaceholder.style.display = 'none';
            };
            reader.readAsDataURL(file);
        } else {
            previewImage.src = '';
            previewImageWrapper.classList.remove('is-visible');
            previewImageWrapper.setAttribute('aria-hidden','true');
            previewPlaceholder.style.display = '';
        }
    }

    function resetDrawerState() {
        if(fileInput) fileInput.value = '';
        updatePreview(null);

        if(resultContainer) resultContainer.classList.add('hidden');
        if(loadingContainer) loadingContainer.classList.add('hidden');
        if(uploadContainer) uploadContainer.classList.remove('hidden');

        // Restore overlaid elements visibility
        if(resultProductPhoto) {
            resultProductPhoto.style.display = '';
        }
        if(likeBtn) {
            likeBtn.classList.remove('liked');
            likeBtn.innerHTML = '<span class="icon">❤️</span> Looks Great';
        }
    }

    if(fileInput){
        fileInput.addEventListener('change', function(){
            const file = fileInput.files && fileInput.files[0];
            updatePreview(file);
        });
    }

    if(openBtn){
        openBtn.addEventListener('click', function(e){
            e.preventDefault();
            openDrawer();
        });
    }

    if(closeBtn){
        closeBtn.addEventListener('click', function(){
            closeDrawer();
        });
    }

    if(backBtn){
        backBtn.addEventListener('click', function(){
            closeDrawer();
        });
    }

    if(generateBtn){
        generateBtn.addEventListener('click', function(e){
            e.preventDefault();
            if (generateBtn.disabled) return;
            if(!fileInput || !fileInput.files || fileInput.files.length === 0){
                alert('Please choose a photo before generating the try-on.');
                return;
            }

            // Extract Shopify context
            let productImageUrl = '';
            let productTitle = 'Product';
            
            if (resultProductPhoto) {
                // If it is a protocol-relative URL (//cdn.shopify.com...), prepend https:
                let src = resultProductPhoto.src || '';
                if (src.startsWith('//')) {
                    src = 'https:' + src;
                }
                productImageUrl = src;
                productTitle = resultProductPhoto.alt || 'Product';
            }

            // Get selected variant (Dawn standard)
            let variantTitle = 'Default';
            const activeOptions = Array.from(document.querySelectorAll('input[type="radio"]:checked')).map(el => el.value);
            if (activeOptions.length > 0) {
                variantTitle = activeOptions.join(' / ');
            }

            const formData = new FormData();
            formData.append('customerPhoto', fileInput.files[0]);
            formData.append('productImageUrl', productImageUrl);
            formData.append('productTitle', productTitle);
            formData.append('variantTitle', variantTitle);

            if(uploadContainer && loadingContainer){
                generateBtn.disabled = true;
                uploadContainer.classList.add('hidden');
                loadingContainer.classList.remove('hidden');

                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 120000); // 120 seconds timeout

                // Send request to Express API
                fetch(`${API_BASE_URL}/api/view-on-me`, {
                    method: 'POST',
                    body: formData,
                    signal: controller.signal
                })
                .then(response => {
                    clearTimeout(timeoutId);
                    generateBtn.disabled = false;
                    if (!response.ok) {
                        return response.json().then(errData => {
                            throw new Error(errData.error || `Server error: ${response.status} ${response.statusText}`);
                        }).catch(() => {
                            throw new Error(`Server returned error status: ${response.status} ${response.statusText}`);
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    if (data && data.success && data.resultUrl) {
                        loadingContainer.classList.add('hidden');
                        resultContainer.classList.remove('hidden');
                        
                        // Render generated image
                        if(resultUserPhoto) {
                            resultUserPhoto.src = data.resultUrl;
                        }
                        // Hide overlaid product photo layer as the result is already composited by backend
                        if(resultProductPhoto) {
                            resultProductPhoto.style.display = 'none';
                        }
                        // Set download URL
                        if(downloadBtn) {
                            downloadBtn.href = data.resultUrl;
                        }
                    } else {
                        throw new Error(data.error || 'Invalid API response');
                    }
                })
                .catch(err => {
                    clearTimeout(timeoutId);
                    generateBtn.disabled = false;
                    console.error('Try-on generation failed:', err);

                    let userMessage = 'Unable to generate your AI Try-On. Please try another photo.';
                    if (err.name === 'AbortError') {
                        userMessage = 'The request timed out. AI try-on generation took too long. Please try again.';
                    } else if (err.message.includes('NetworkError') || err.message.includes('Failed to fetch') || err.name === 'TypeError') {
                        userMessage = 'Network connection failed or backend is offline. Please check your internet connection or try again later.';
                    } else if (err.message) {
                        userMessage = `Try-on generation failed: ${err.message}`;
                    }

                    alert(userMessage);
                    resetDrawerState();
                });
            }
        });
    }

    if(resetBtn){
        resetBtn.addEventListener('click', function(e){
            e.preventDefault();
            resetDrawerState();
        });
    }

    if(likeBtn){
        likeBtn.addEventListener('click', function(e){
            e.preventDefault();
            likeBtn.classList.toggle('liked');
            if (likeBtn.classList.contains('liked')) {
                likeBtn.innerHTML = '<span class="icon">💖</span> Liked!';
            } else {
                likeBtn.innerHTML = '<span class="icon">❤️</span> Looks Great';
            }
        });
    }

    if(cartBtn){
        cartBtn.addEventListener('click', function(e){
            e.preventDefault();
            
            // Fetch selected variant ID from buy button form input
            const variantIdInput = document.querySelector('input[name="id"]');
            if (!variantIdInput) {
                alert('Could not find active variant ID on this product page.');
                return;
            }
            
            const variantId = variantIdInput.value;
            
            cartBtn.classList.add('loading');
            
            // Add to cart via AJAX API
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            })
            .then(response => {
                if (!response.ok) throw new Error('Cart API add failed');
                return response.json();
            })
            .then(data => {
                cartBtn.classList.remove('loading');
                alert('Product added to your cart successfully!');
                // Redirect to cart or dispatch event
                document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
                window.location.href = '/cart';
            })
            .catch(err => {
                cartBtn.classList.remove('loading');
                console.error('Add to cart failed:', err);
                alert('Could not add variant to cart. Please try again.');
            });
        });
    }

    // Close on ESC
    window.addEventListener('keydown', function(e){
        if(e.key === 'Escape' || e.key === 'Esc'){
            if(drawer && drawer.classList.contains('is-open')){
                closeDrawer();
            }
        }
    });

});